<template>
  <div>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="500"
      :data="tableData"
      :loading="loading"
      align="center"
    >
      <vxe-table-column field="merchantId" title="⽹商商户号" min-width="180" />
      <vxe-table-column
        field="outTradeNo"
        title="外部交易流水号"
        min-width="300"
      />
      <vxe-table-column field="orderNo" title="预申请订单号" min-width="350" />
      <vxe-table-column
        field="signStatus"
        title="签约状态"
        min-width="100"
        :formatter="
          ({ cellValue }) => formatterField({ cellValue }, 'signStatus')
        "
      />
      <vxe-table-column
        field="signType"
        title="签约方式"
        min-width="100"
        :formatter="
          ({ cellValue }) => formatterField({ cellValue }, 'signType')
        "
      />
      <vxe-table-column field="name" title="实际承运人姓名" min-width="100" />
      <vxe-table-column
        field="phone"
        title="实际承运人手机号"
        min-width="130"
      />
      <!--      <vxe-table-column-->
      <!--        field="loadStatus"-->
      <!--        title="车辆负载状态"-->
      <!--        min-width="130"-->
      <!--        :formatter="({ cellValue }) => formatterField({ cellValue }, 'loadStatus')"-->
      <!--       />-->
      <vxe-table-column field="gmtCreated" title="创建时间" min-width="150" />
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="form.pageNum"
      :page-size.sync="form.pageSize"
      :total="form.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import {
  getprodMerchRecord,
  getprodMerchRecordShipmentList
} from "@/api/InternetBanking";
export default {
  name: "ProdMerchRecord",
  data() {
    return {
      tableData: [],
      Pagingconf: [],
      loading: false,
      form: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        partyCode: ""
      },
      acceptTypeOptions: [
        { label: "余额⽀付免短验签约", value: "balancePaySign" },
        { label: "定向⽀付免短验签约", value: "directBalancePaySign" }
      ],
      loadStatusOptions: [
        { label: "空载", value: 0 },
        { label: "负载", value: 1 }
      ],
      signStatusOptions: [
        { label: "已申请", value: 0 },
        { label: "已签约", value: 1 },
        { label: "签约取消", value: 2 }
      ],
      signTypeOptions: [
        { label: "线上", value: 0 },
        { label: "线下", value: 1 }
      ],
      type: ""
    };
  },
  created() {},
  methods: {
    // 获取详情
    getInfo(code, type) {
      this.form.partyCode = code;
      this.type = type;
      this.findList();
    },
    findList() {
      this.loading = true;
      //console.log(this.type);
      return new Promise(resolve => {
        if (this.type == "driver") {
          getprodMerchRecord(this.form)
            .then(response => {
              this.tableData = response.data.records;
              this.form.total = response.data.total;
              response.data.total > 10000
                ? (this.Pagingconf = [20, 30, 50, 100, 10000])
                : (this.Pagingconf = [
                    20,
                    30,
                    50,
                    100,
                    response.data.total || 1
                  ]);
              this.loading = false;
              resolve();
            })
            .catch(() => {
              this.loading = false;
            });
        } else if (this.type == "shipment") {
          getprodMerchRecordShipmentList(this.form)
            .then(response => {
              this.tableData = response.data.records;
              this.form.total = response.data.total;
              response.data.total > 10000
                ? (this.Pagingconf = [20, 30, 50, 100, 10000])
                : (this.Pagingconf = [
                    20,
                    30,
                    50,
                    100,
                    response.data.total || 1
                  ]);
              this.loading = false;
              resolve();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      });
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value == cellValue
      );
      return item ? item.label : "";
    },
    handlePageChange({ currentPage, pageSize }) {
      this.form.pageNum = currentPage;
      this.form.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>
